import Lenis from 'lenis';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { initAnimations } from './globalAnimations';

gsap.registerPlugin(ScrollTrigger);

// Smooth scroll

export const lenis = new Lenis({
  lerp: 0.075,
  wheelMultiplier: 1.3,
  touchMultiplier: 1.3,
  keyboard: false,
})

lenis.on('scroll', ScrollTrigger.update);

gsap.ticker.add((time) => {
  lenis.raf(time * 1000);
});

export const initAnim = () => {
  // Prevent page scrolling on press space
  window.addEventListener('keydown', (event) => {
    const isEditable = ['INPUT', 'TEXTAREA'].includes(event.target.tagName) || event.target.isContentEditable;

    if (!isEditable  && event.code === 'Space') {
      event.preventDefault();
    }
  });

  initAnimations()

  const hero = document.querySelector(".js-parallax-hero");

  function setHeroParallax() {
    if (!hero) return;

    const video = hero.querySelectorAll("video");
    const isMobile = window.innerWidth < 768;

    ScrollTrigger.getById("hero-parallax")?.kill();

    if (video.length > 0) {
      video.forEach(item => {
        gsap.set(item, {
          y: 0,
          objectPosition: isMobile ? "77% center" : "50% center",
        });

        gsap.to(item, {
          y: () => innerHeight,
          ease: "none",
          scrollTrigger: {
            id: "hero-parallax",
            trigger: window.body,
            start: "top top",
            end: "bottom top",
            scrub: true,
          },
        });
      })
      
      return;
    }

    hero.style.top = isMobile ? "77% 0px" : "50% 0px";

    gsap.to(hero, {
      top: () => `${innerHeight}px`,
      ease: "none",
      scrollTrigger: {
        id: "hero-parallax",
        trigger: window.body,
        start: "top top",
        end: "bottom top",
        scrub: true,
      },
    });

    gsap.to(".footer-parallax", {
      y: "-30%",
      ease: "none",
      scrollTrigger: {
        trigger: ".footer",
        start: "top bottom",
        end: "bottom bottom",
        scrub: true,
      },
    });
  }

  setHeroParallax();
  window.addEventListener("resize", setHeroParallax);

  return {
    init() {},
  }
};
